module.exports = __webpack_public_path__ + "img/layout-1.677fdf26.png";